
import {operationValidationCatch} from '@/utils/operationFeedback'

import {readRememberedAccount} from '@/utils/rememberedAccount'
import {clientLoginContext} from '@/utils/loginContext'
import ProductConsultationInfo from '@/views/components/ProductConsultationInfo.vue'
import WechatBindingFlow from '@/components/InlineWechatBinding.vue'

import { defineComponent, onMounted,computed,ref,watch, onActivated,onBeforeUnmount } from 'vue'
import {createWechatLoginState} from '@/utils/wechatLoginState'
import {useClientPageSettings} from '@/composables/useClientPageSettings'
// 2026-09-30：窄屏复用小程序式导航，保留原业务操作。
import MobileNavigation from './MobileNavigation.vue'
import store from '@/store'
import router from '@/router'
// 2026-10-07：详情点击原分类返回商品所在页，包含平板导航和手机更多菜单。
import { returnToCatalog } from '@/utils/catalogReturnNavigation'
import Screenfull from './Screenfull.vue'
import SearchText from './SearchText.vue'
import {guid} from '@/utils/help'
import wxlogin from 'vue-wxlogin'
import sysRequest from '@/api/sys'
import Hanbuger from './Hanbuger.vue'
import Navgater from './Navgater.vue'
import customerRequest from '@/api/customer'
import Language from './Language.vue'
import ClientSkinPicker from '@/components/ClientSkinPicker.vue'
import {message} from 'ant-design-vue'
import CBridge from '@/components/cBirdge/CBridge.vue'
import { generateTitle } from '@/utils/lang'
import {UserInfo} from '@/Interfaces/user/user'
import MenuItem from '@/Interfaces/user/MenuItem'
import { setTimestamp } from '@/utils/auth'
import {useRoute} from 'vue-router'
import {usePasswordReminder} from '@/utils/passwordReminder'
import QrcodeVue from 'vue-qrcode';  
import { UserOutlined,KeyOutlined,MobileOutlined,MailOutlined } from '@ant-design/icons-vue'
declare class WxLogin {
  constructor(options: {
    self_redirect: boolean;
    id: string;
    appid: string;
    scope: string;
    redirect_uri: string;
    state: string;
    style: string;
    href: string;
  });
  // 如果WxLogin类有其他方法或属性，也应该在这里声明
}
export default defineComponent({
  setup() {
    const {pageText,pageImage}=useClientPageSettings()
    const navigationImages={light:require('@/assets/images/logo-light.png'),dark:require('@/assets/images/logo-dark.png')}
    const navigationTitle=(menu:any)=>pageText('common.nav.'+String(menu.path).split('/').pop()) || menu.title
    const iconSetting = ref<string>('link')
    const open=ref(false)
    const showRegForm=ref(false)
    const showSmsTerms=ref(false)
    const isWxLogin=ref(false)
    const acceptTerm=ref(false)
    // 2026-09-22：验证码自动注册须单独明确同意协议，默认不勾选且不沿用其他登录方式的状态。
    const codeAcceptTerm=ref(false)
    const loginPreview=new URLSearchParams(location.search).get('loginPreview')==='1'
    const verifiedBindingPreview=new URLSearchParams(location.search).get('verifiedBindingPreview')==='1'
    const bindingFlow=ref(verifiedBindingPreview || new URLSearchParams(location.search).get('bindingStatusPreview')==='1')
    const bindingLoginRequested=ref(false)
    const inlineBindingUser=ref<any>(null)
    function continueBinding(){inlineBindingUser.value=null;showLoginForm.value=false;bindingFlow.value=true}
    function inlineBindingAuthenticated(data:any){inlineBindingUser.value=data;setTimestamp();initWebSocket();const menu=menus.value.find(item=>item.path==='/main/buycar');if(menu)menu.enabled=clientFunctionVisible('购物车')}
    function closeInlineBinding(){bindingFlow.value=false;const data=inlineBindingUser.value;inlineBindingUser.value=null;if(data?.passwordResetRequired===true&&Number(store.getters.userInfo.id)===Number(data.id)){isForeceReset.value=true;accountInfo.value.username=data.loginName;accountInfo.value.password='jaxlipassword!_';passwordReminder.request(true)}}
    const islogin=ref(true)
    const showRegAccountForm=ref(false)
    const formInfo=ref()
    const validation=ref({phone:'',code:''})
    const loginInfo=ref<UserInfo>(readRememberedAccount(window.localStorage,'userdata'))
    const clearMigratedPassword=(event:Event)=>{const detail=(event as CustomEvent).detail;if(detail?.role==='cus' && detail.username===loginInfo.value.username)loginInfo.value.password=''}
    onMounted(()=>window.addEventListener('legacy-account-migrated',clearMigratedPassword))
    onBeforeUnmount(()=>window.removeEventListener('legacy-account-migrated',clearMigratedPassword))
    const resetPwd=ref({phone:'',password:'',code:'',phoneStatus:'',newPwdStatus:'',codeStatus:''})
    const activeKey=ref(loginPreview && new URLSearchParams(location.search).get('loginMethodPreview')==='sms'?2:1)
    const showApp=ref(true)
    const bindingPhone=ref()
    const getValidaCodeText=ref('获取验证码')
    const confirmExit=ref(false)
    const accountMenuVisible=ref(false)
    const regAccountFormInfo=ref()
    const appletQrcode=ref('')
    const route=useRoute()
    const logout = () => {
      store.dispatch('user/logout')
      if(store.state.app.socket){
        store.state.app.socket.close()
      }
      confirmExit.value=false
      message.success("您已成功退出。")
      location.href="/main/bokes?k="+new Date().getTime().toString()
    }
    const bindingData=ref({code:'',phone:''})
    const newAccountInfo=ref<any>({})
    let hasStarted=false
    const showPhoneBinding=ref(false)
    const wechatScanError=ref('')
    const bingdingResult=ref({phone:'',openid:''})
    watch(()=>route.path,(newPath)=>{
      console.log(newPath)
      if(newPath==='/main/bokes'){
        selectedIndex.value=1
      }else if(newPath==='/main/cloths'){
        selectedIndex.value=2
      }else if(newPath==='/main/retails'){
        selectedIndex.value=3
      }
    })
    let bingdingT:number|undefined,scanGeneration=0,scanBusy=false
    const stopWechatPolling=()=>{scanGeneration++;hasStarted=false;scanBusy=false;if(bingdingT)window.clearInterval(bingdingT);bingdingT=undefined}
    const keyChanged=(key)=>{
      stopWechatPolling()
      if(String(key)!=='3')return
      showPhoneBinding.value=false;bindingData.value={phone:'',code:''};wechatScanError.value='';wxLoginstate.value={t:createWechatLoginState(),orgId:store.getters.orgId};hasStarted=true
      const generation=scanGeneration,state={...wxLoginstate.value}
      bingdingT=window.setInterval(async()=>{
        if(scanBusy || generation!==scanGeneration)return
        scanBusy=true
        try{
          const res=await sysRequest.getWxLoginResult(state)
          if(generation!==scanGeneration || String(activeKey.value)!=='3' || !showLoginForm.value || state.orgId!==store.getters.orgId)return
          if(!res.data?.openid)return
          stopWechatPolling();bingdingResult.value=res.data
          if(!res.data.phone){showPhoneBinding.value=true;return}
          await store.dispatch('user/codeLogin',{phone:res.data.phone,code:'',wechatState:state.orgId+'_C_'+state.t})
          setTimestamp();showLoginForm.value=false;activeKey.value=1
        }catch(error:any){if(showLoginForm.value && state.orgId===store.getters.orgId && state.t===wxLoginstate.value.t && String(activeKey.value)==='3'){stopWechatPolling();wechatScanError.value=error?.message || '扫码登录失败，请重新扫码';message.warn(wechatScanError.value)}}
        finally{if(generation===scanGeneration)scanBusy=false}
      },3000)
    }

    onBeforeUnmount(stopWechatPolling)
    const previliges=computed(()=>{
      return store.getters.previliges
    })
    // 2026-08-24：客户类型功能全部展示；只有分店C端在超出当前VIP时引导升级。
    const vipVisibleFunctions=computed(()=>store.getters.vipVisibleFunctions || {})
    const vipAllowedFunctions=computed(()=>store.getters.vipAllowedFunctions || {})
    // 2026-08-31：分店角色关闭功能时入口必须隐藏；仅客户VIP等级不足时仍保留入口用于升级提示。
    const clientFunctionVisible=(functionName:string)=>functionName==='帮助中心' && Number(orgId.value)!==1000
      ? Number(store.getters.orgInfo?.id)===Number(orgId.value) && store.getters.orgInfo?.helpCenterEnabled===true
      : Boolean(previliges.value[functionName] || vipVisibleFunctions.value[functionName])
    const downloadIcon=()=>{ 
        // 动态创建一个 a 标签
        const aTag = document.createElement('a');
        aTag.href = appletQrcode.value;
        aTag.download = '小程序太阳码.zip';  // 设置下载后的文件名
        document.body.appendChild(aTag);
        aTag.click();        
        document.body.removeChild(aTag);
    }
    const orgId=computed(()=>{
      return store.getters.orgId
    })
    const userId=computed(()=>{
      return store.getters.userInfo.id
    })
    const showupdatePwd=()=>{
      passwordReminder.manual()
      open.value=true
      accountInfo.value.username=store.getters.userInfo.loginName
    }

    // 2026-10-18：语言切换仅刷新导航标题，保留菜单计数、权限及选中路由。
    const menus = ref<MenuItem[]>([
      {
        title: generateTitle('main.index'),
        path: '/main/index',
        icon: 'personnel-manage',
        enabled:true
      },
      {
        title: generateTitle(previliges.value['版型下单']?'main.bokes':'main.bokesBranch'),
        path: '/main/bokes',
        flag:'版型库浏览',
        icon: 'personnel-manage',
        enabled:false
      },
      {
        title: generateTitle('main.cloths'),
        path: '/main/cloths',
        flag:'成衣定制浏览与下单',
        icon: 'personnel-manage',
        enabled:false
      },
      {
        title: generateTitle('main.retails'),
        path: '/main/retails',
        flag:'成衣现货浏览与下单',
        icon: 'personnel-manage',
        enabled:false
      },  
      {
        title: generateTitle('main.fabrics'),
        path: '/main/fabrics',
        flag:'面料浏览与下单',
        icon: 'personnel-manage',
        enabled:false
      },  
      {
        title: generateTitle('main.accessories'),
        path: '/main/accessories',
        flag:'辅料浏览与下单',
        icon: 'personnel-manage',
        enabled:false
      },  
      {
        title: generateTitle('main.decorations'),
        path: '/main/decorations',
        flag:'饰品浏览与下单',
        icon: 'personnel-manage',
        enabled:false
      },
      {
        title: generateTitle('main.buycar'),
        path: '/main/buycar',
        flag:'购物车',
        icon: 'personnel-manage',
        enabled:false
      },   
      {
        title: generateTitle('main.coursecenter'),
        path: '/main/coursecenter',
        flag:'制版教学',
        icon: 'personnel-manage',
        enabled:false
      },{
        title: generateTitle('main.helpcenter'),
        path: '/main/helpcenter',
        flag:'帮助中心',
        icon: 'personnel-manage',
        enabled:false
      }
    ])
    const scaleClick=()=>{
      if(Number(orgId.value)!==1000 && vipVisibleFunctions.value['智能量体'] && !vipAllowedFunctions.value['智能量体']){
        message.info('智能量体需要升级VIP后使用')
        router.push('/main/upgradeLevel')
        return
      }
      if(userId.value){
        router.push("/main/autoscale")
      }else{
        showLoginForm.value=true
      }
      
    }
    const selectedIndex = ref(0)
    const menuclick = (menu, index) => {
      // 2026-09-29：切店或权限变化后，旧帮助按钮事件也须服从当前分店类型与原权限。
      if(menu.path==='/main/helpcenter' && !helpCenterVisible.value)return
      // 购物车始终占据同一导航位置；未登录时由入口提示登录。
      if(menu.path==='/main/buycar' && !logined.value){showLoginForm.value=true;return}
      if(menu.path!=='/main/helpcenter' && Number(orgId.value)!==1000 && menu.flag && vipVisibleFunctions.value[menu.flag] && !vipAllowedFunctions.value[menu.flag]){
        message.info(`“${menu.title}”需要升级VIP后使用`)
        router.push('/main/upgradeLevel')
        return
      }
      selectedIndex.value = index      
      if (!returnToCatalog(router, menu.path, String(store.getters.orgId) + ':' + String(store.getters.userInfo.id || 0))) {
        router.push(menu.path)
      }
      if(orgInfo.value.id==1000){       
          if(menu.path=='/main/index'){
            showApp.value=false;
          }else{
            showApp.value=true;
          }
        }
    }
    const bindPhoneButton=ref('获取验证码')
    const accountInfo=ref({
      username:store.getters.userInfo.loginName,
      password:'',
      newPassword:''
    })
    
    const bingding=async()=>{
      if(!validatePhoneNumber(bindingData.value.phone) || !/^\d{6}$/.test(bindingData.value.code)){message.warn('请输入正确的手机号和验证码');return}
      try{
        await store.dispatch('user/codeLogin',{...bindingData.value,wechatState:wxLoginstate.value.orgId+'_C_'+wxLoginstate.value.t})
        setTimestamp();showLoginForm.value=false;showPhoneBinding.value=false;message.success('绑定成功,并自动完成登录。')
      }catch(error:any){message.warn(error?.message || '绑定失败，请重新扫码')}
    }
    // 2026-08-01 17:22：保持客户端密码至少 6 位的原规则，并允许使用英文句点和感叹号。
    const clientPasswordRegex=/^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9.!]{6,}$/
    const pwdError=ref(false)
    const resetPwdClick=()=>{      
      if(resetPwd.value.code=="" || resetPwd.value.code.length!=6){
        message.error('验证码不正确或未填写。')
        return
      }     
      pwdError.value=false
      resetPwd.value.newPwdStatus=""
      if (!clientPasswordRegex.test(resetPwd.value.password)) {
        resetPwd.value.newPwdStatus="error"
        message.error('密码至少6位，包含字母与数字，可使用 . 和 !。');
        pwdError.value=true
        return; 
      }
      customerRequest.resetPwd(resetPwd.value).then(res=>{
        message.success('密码重置成功！')
        islogin.value=true
      }).catch(err=>{
        message.error(err.message)
      })
    }
    const sendCode=()=>{
      //if(bindingPhone.value){
      //  bindingPhone.value.validate().then(res=>{
          if(validatePhoneNumber(bindingData.value.phone)){
            const token=guid().substring(0,8)   
            codeState.value.regPhone=""
            accountExists.value=false
            sysRequest.sendValideCodeForBinding(bindingData.value.phone,token).then(res=>{
              if(res.data==-1){
                message.error('获取验证码失败')
                return
              }else if(res.data==-2){
                message.error('手机号码不存在，请注册账号后再登录。')
                return
              }        
                 
              let index=60
              let intev=setInterval(()=>{
                index--
                bindPhoneButton.value=`${index}秒后重新获取`
                if(index==0){
                  bindPhoneButton.value='获取验证码'
                  clearInterval(intev)
                }
              },1000)
            })
          }else{
            message.error('请录入正确的手机号码！');
            codeState.value.regPhone='error'
          }
      //  })
      //}
    }
    const validatePhoneNumber=(phoneNumber)=> {
      const regex = /^1[3-9]\d{9}$/;
      return regex.test(phoneNumber);
    }
    //const wxloginData=ref({appid:'wx8ea559b871f290f1',redirectUrl:encodeURIComponent("http://v3.landidz.com/api/land/receiveCode")})
    const wxloginData=ref({appid:process.env.VUE_APP_APPID,redirectUrl:encodeURIComponent(process.env.VUE_APP_LOGIN_URL)})
    const wxLogin=()=>{
      isWxLogin.value=true
      // const obj = new WxLogin({
      //   self_redirect:true,
      //   id:"login_container", 
      //   appid: "wx8ea559b871f290f1", 
      //   scope: "snsapi_login", 
      //   redirect_uri:encodeURIComponent("http://v3.landidz.com/api/receiveCode"),
      //     state: store.getters.orgId,
      //   style: "black",
      //   href: ""
      //   });
        
    }
    const codeState=ref({code:'',phone:'',regPhone:'',loginName:''})
    // 2026-09-22：发送短信与注册提交共用选填登录名规则，不生成或代填真实姓名。
    const registrationLoginName=()=>String(newAccountInfo.value.loginName || '').trim() || String(newAccountInfo.value.cellphone || '').trim()
    // 2026-09-09：注册短信失败统一提示并恢复按钮，避免未处理异常、内部信息回显和重复发送。
    const getValidaCodeForReg=async()=>{
      if(getValidaCodeText.value!='获取验证码') return
      // 2026-09-22：手机号去除首尾空格后用于登录名默认值及短信验证，保持两次提交一致。
      newAccountInfo.value.cellphone=String(newAccountInfo.value.cellphone || '').trim()
      if(validatePhoneNumber(newAccountInfo.value.cellphone)){
        getValidaCodeText.value='发送中…'
        const failureMessage='验证码暂时无法发送，请稍后重试；如持续失败，请联系客服。'
        try{
          const token=guid().substring(0,8)
          codeState.value.regPhone=""
          codeState.value.phone=''
          codeState.value.loginName=''
          accountExists.value=false
          const res=await sysRequest.sendValideCodeForReg(newAccountInfo.value.cellphone,registrationLoginName(),token)
          if(res?.data==-2){
            message.error('该手机号码已注册，请直接登录。')
            codeState.value.regPhone='error'
            return
          }else if(res?.data==-3){
            message.error('该登录名已注册，请更换登录名。')
            codeState.value.loginName='error'
            accountExists.value=true
            return
          }else if(res?.data!=1){
            message.error(failureMessage)
            return
          }
          let index=60
          getValidaCodeText.value=`${index}秒后重新获取`
          const intev=setInterval(()=>{
            index--
            getValidaCodeText.value=`${index}秒后重新获取`
            if(index==0){
              getValidaCodeText.value='获取验证码'
              clearInterval(intev)
            }
          },1000)
        }catch{
          message.error(failureMessage)
        }finally{
          if(getValidaCodeText.value==='发送中…') getValidaCodeText.value='获取验证码'
        }
      }else{
        message.error('请录入正确的手机号码！');
        codeState.value.regPhone='error'
      }
    }
    const getValidaCode=async(phone,autoRegister=false)=>{
      if(getValidaCodeText.value!=='获取验证码')return
      // 2026-09-22：新手机号短信仅由已同意协议的自动注册入口申请，重置密码等旧流程不传开启标记。
      if(autoRegister===true && !codeAcceptTerm.value){
        message.warn('请先阅读并同意注册使用条款')
        return
      }
      phone=String(phone || '').trim()
      if(validatePhoneNumber(phone)){
        const token=guid().substring(0,8)   
        codeState.value.phone=""
        resetPwd.value.phoneStatus=''
        getValidaCodeText.value='发送中…'
        const failureMessage='验证码暂时无法发送，请稍后重试；如持续失败，请联系客服。'
        try{
          const res=await sysRequest.sendValideCode(phone,token,autoRegister===true)
          if(res?.data===-2){
            message.error('手机号码没有注册，请核对手机号或先注册。')
            codeState.value.phone='error'
            resetPwd.value.phoneStatus='error'
            return
          }
          if(res?.data!==1){message.error(failureMessage);return}
          let index=60
          getValidaCodeText.value=`${index}秒后重新获取`
          let intev=setInterval(()=>{
            index--
            getValidaCodeText.value=`${index}秒后重新获取`
            if(index==0){
              getValidaCodeText.value='获取验证码'
              clearInterval(intev)
            }
          },1000)
        }catch{
          message.error(failureMessage)
        }finally{
          if(getValidaCodeText.value==='发送中…')getValidaCodeText.value='获取验证码'
        }
      }else{
        message.error('请录入正确的手机号码！');
        codeState.value.phone='error'
        resetPwd.value.phoneStatus='error'
      }
    }
    const path=computed(()=>{
      return router.currentRoute.value.path
    })
    const viewAccount=()=>{
      router.push("/main/cuscenter/info")
    }
    const accountExists=ref(false)
    const regAccount=()=>{
      // 2026-09-22：选填姓名只保留用户输入，手机号默认登录名仍受原注册条款确认约束。
      if(!acceptTerm.value){
        message.warn('请先阅读并同意注册使用条款')
        return
      }
      accountExists.value=false
      if(regAccountFormInfo.value){
        regAccountFormInfo.value.validate().catch(operationValidationCatch()).then(res=>{
          // 2026-09-22：默认登录名只写入提交快照，验证码失败后更换手机号不会把旧默认值当成用户自填登录名。
          const registrationData={...newAccountInfo.value,
            loginName:registrationLoginName(),
            cellphone:String(newAccountInfo.value.cellphone || '').trim(),
            nickName:String(newAccountInfo.value.nickName || '').trim(),
            orgId:store.getters.orgId}
          customerRequest.getUserCount(registrationData.loginName).then(res=>{
            if(res.data==0){
              registrationData.displayLevel=0
              registrationData.executeLevel=0
              registrationData.sourceFrom="PC"
              registrationData.displayLevelText='普通用户'
              registrationData.disable=0
              registrationData.blocked=0
              registrationData.limit=0
              registrationData.levelExpired=new Date().getTime()
              registrationData.lastLogin=new Date().getTime()
              customerRequest.addClient(registrationData).then(res=>{
                if(res.data>0){
                  store.dispatch('user/login',{"username":registrationData.loginName,"password":registrationData.password}).then((res) => {
                    setTimestamp()
                    const menu=menus.value.find(item=>item.path==='/main/buycar')
                    if(menu){
                      menu.enabled=clientFunctionVisible('购物车')
                    }  
                    initWebSocket()
                    message.success("注册成功，已为您登入系统，您可以畅享服装定制啦。")
                    showRegAccountForm.value=false
                    showLoginForm.value=false
                  })
                  .catch((err) => {
                    message.warn(err.message)
                  })
                }
              }).catch(err=>{
                message.warn(err.message)
              })
            }else{
              accountExists.value=true
              message.warn(`${registrationData.loginName}已存在，请换个登录名。`)
            }            
          })
        })
      }
      
      
    }
    const loginContext=computed(()=>clientLoginContext(store.getters.orgInfo,Number(store.getters.orgId)))
    const orgInfo=computed(()=>{
      return store.getters.orgInfo
    })
    // 2026-11-03：帮助访问独立于全功能计价身份，分店仅按当前机构的VIP总控开关显示。
    const helpCenterVisible=computed(()=>{
      const currentOrgId=Number(orgId.value)
      if(currentOrgId===1000)return true
      return Number.isInteger(currentOrgId) && currentOrgId>1000
        && Number(orgInfo.value?.id)===currentOrgId
        && orgInfo.value?.helpCenterEnabled===true
    })
    // 2026-10-12：保持原可见权限筛选，隐藏栏目不占用导航间距。
    watch(()=>store.getters.language,()=>{
      const keys=['main.index',previliges.value['版型下单']?'main.bokes':'main.bokesBranch','main.cloths','main.retails','main.fabrics','main.accessories','main.decorations','main.buycar','main.coursecenter','main.helpcenter']
      menus.value.forEach((menu,index)=>{if(keys[index])menu.title=generateTitle(keys[index])})
    },{flush:'post'})
    const mobileNavigationMenus=computed(()=>menus.value.filter(menu=>menu.path!=='/main/helpcenter' || helpCenterVisible.value).map(menu=>({...menu,title:navigationTitle(menu)})))
    const navigationMenus=computed(()=>menus.value.filter(menu=>menu.path==='/main/helpcenter'?helpCenterVisible.value && (Number(orgId.value)!==1000 || menu.enabled):menu.enabled))
    const  validatePassword=(rule, value, callback)=> {
      // 正则表达式，要求密码至少6个字符，至少一个数字，一个小写和一个大写字母  
      if (value === '') {  
        callback(new Error('请录入新密码!'));  
      } else if (!clientPasswordRegex.test(value)) {
        callback(new Error('密码至少6位，包含字母与数字，可使用 . 和 !。'));
      } else {  
        callback();  
      }
    }
    const retryValidatePassword=(rule, value, callback)=>{
      if (value === '') {  
        callback(new Error('请录入新密码!'));  
      } else if (!clientPasswordRegex.test(value)) {
        callback(new Error('密码至少6位，包含字母与数字，可使用 . 和 !。'));
      } else if(newAccountInfo.value.password!=value){  
        callback(new Error('两次密码不一致。'));  
      }else{
        callback();  
      }
    }
    const logined=computed(()=>{
      return store.getters.userInfo.id
    })
    const userInfo=computed(()=>{
      return store.getters.userInfo
    })
    const validateCode=(phoneNumber)=> {
      const regex = /^\d{6}$/;
      return regex.test(phoneNumber);
    }
    const reconnectInterval = 5000;
    let socketRef
    const initWebSocket = () => {
      if (socketRef) {
        socketRef.close();
      }
      const wsfapi = process.env.VUE_APP_BASE_WS + 'cus' + store.getters.userInfo.id;
      socketRef = new WebSocket(wsfapi);      
      socketRef.onopen=()=>{
        console.log('ws connected');
      };
      socketRef.onmessage=(event)=>{
        const msg = JSON.parse(event.data);
        console.log(msg)
        //if(msg.messageType==1){   //体形照片信息
          if(store.state.app.bodyImageMsg){
            store.state.app.bodyImageMsg(msg)
          }
        //}else{
          if(store.getters.onmessage){         
            store.getters.onmessage(event)
          }
        //}
      }
      socketRef.onclose = () => {
        console.log('WebSocket disconnected. Reconnecting in ' + reconnectInterval / 1000 + ' seconds...');
        setTimeout(initWebSocket, reconnectInterval); // 设置定时器进行重连
      };
      socketRef.addEventListener('error', (error) => {
        console.error('WebSocket error:', error);
      });
      store.state.app.socket=socketRef
    };
    const isForeceReset=ref(false)
    const passwordReminder=usePasswordReminder(
      ()=>store.getters.token && store.getters.userInfo?.id && Number(store.getters.orgId)===Number(store.getters.userInfo.orgId)?JSON.stringify(['web',store.getters.userInfo.id,store.getters.userInfo.orgId]):'',
      ()=>route.path,['/','/main','/main/index'],open,first=>{
        isForeceReset.value=first;accountInfo.value.username=store.getters.userInfo.loginName
        if(first)accountInfo.value.password='jaxlipassword!_'
      })
    const codeLogin=()=>{
      stopWechatPolling()
      // 2026-09-22：仅已告知并明确同意协议的短信入口允许自动注册；微信等既有调用保持原行为。
      if(!bindingLoginRequested.value && !codeAcceptTerm.value){
        message.warn('请先阅读并同意注册使用条款')
        return
      }
      validation.value.phone=String(validation.value.phone || '').trim()
      validation.value.code=String(validation.value.code || '').trim()
      store.state.user.token=null 
      codeState.value.code=''
      codeState.value.phone=''
      if(!validateCode(validation.value.code)){
        message.warn('请输入正确的验证码')
        codeState.value.code='error'
        return
      } 
      if(validatePhoneNumber(validation.value.phone)){    
        store.dispatch('user/codeLogin',{...validation.value,autoRegister:!bindingLoginRequested.value,remebmer:loginInfo.value.remebmer}).then((res) => {
          setTimestamp()
          if(res){            
            // 2026-09-20：验证码登录只读取改密状态，不再依赖响应中的密码字段。
            if(res.passwordResetRequired===true){
              passwordReminder.request(true)
              isForeceReset.value=true
              accountInfo.value.username=res.loginName
              accountInfo.value.password="jaxlipassword!_"
            }
            initWebSocket()
            showLoginForm.value=false
            const menu=menus.value.find(item=>item.path==='/main/buycar')
            if(menu){
              menu.enabled=clientFunctionVisible('购物车')
            }  
          }          
        })
        .catch((err) => {
          message.warn(err.message)
        })
      }else{
        message.warn('请输入正确的手机号')
        codeState.value.phone='error'
      }
    }
    const loginClick=()=>{
      stopWechatPolling()
      store.state.user.token=null      
      return store.dispatch('user/login',loginInfo.value)
        .then((res) => {
          setTimestamp()
          initWebSocket()
          showLoginForm.value=false
          const menu=menus.value.find(item=>item.path==='/main/buycar')
          if(menu){
            menu.enabled=clientFunctionVisible('购物车')
          }  
          
          if(loginInfo.value.password=='123456'){
            message.success("登录成功")
            // router.push({
            //   path:'/main/bokes'
            // })

            passwordReminder.request()
          }else{
            message.success("登录成功")
            window.location.reload()
          }
        })
        .catch((err) => {
          message.warn(err.message)
        })
    }
    
    const showLoginForm=ref(new URLSearchParams(location.search).get('loginPreview')==='1' && new URLSearchParams(location.search).get('bindingStatusPreview')!=='1' && !verifiedBindingPreview)
    watch([activeKey,showLoginForm,()=>store.getters.orgId],([key,visible])=>{
      showPhoneBinding.value=false;bindingData.value={phone:'',code:''}
      if(visible)keyChanged(key);else stopWechatPolling()
    })
    const updatePwd=()=>{
      formInfo.value.validate().catch(operationValidationCatch()).then(()=>{
        if(clientPasswordRegex.test(accountInfo.value.newPassword)){
          sysRequest.updatePwd(accountInfo.value).then(res=>{
            open.value=false
            passwordReminder.clear()
            message.success('密码修改成功。')
            isForeceReset.value=false
            accountInfo.value.password=""
            accountInfo.value.newPassword=""
          }).catch(err=>{
            message.error("原始密码错误，请核对后再发起修改。")
          })
        }  
      })      
    }
    // 2026-10-01：充值优惠仅对已登录且开放会员储值、存在启用档位的当前门店显示；旧请求不串门店。
    const rechargeAvailable=ref(false)
    const guestRechargeVisible=computed(()=>!logined.value && route.path!=='/main/index' && Number.isInteger(Number(orgId.value)) && Number(orgId.value)>=1000)
    const rechargeVisible=computed(()=>guestRechargeVisible.value || Boolean(logined.value && clientFunctionVisible('会员储值') && rechargeAvailable.value))
    // 2026-10-11：仅商品详情显示悬浮储值优惠，首页不再显示；各路由复用同一资格判断。
    const detailRechargeVisible=computed(()=>route.meta.storedValueOffer===true && rechargeVisible.value)
    const detailRechargeStyle=ref<Record<string,string>>({})
    let rechargeSizeObserver:ResizeObserver|undefined,observedRechargeElement:Element|undefined
    const positionDetailRecharge=()=>{
      if(typeof document==='undefined'||typeof window==='undefined'||!detailRechargeVisible.value)return
      if(route.path==='/main/buycourse'){detailRechargeStyle.value={};return}
      const width=window.innerWidth,height=window.innerHeight,element=document.querySelector('.detail-stored-value-offer'),button=element?.getBoundingClientRect();if(!button||!element)return
      if(element!==observedRechargeElement&&typeof ResizeObserver!=='undefined'){rechargeSizeObserver?.disconnect();rechargeSizeObserver=new ResizeObserver(()=>queueDetailRecharge());rechargeSizeObserver.observe(element);observedRechargeElement=element}
      // 校正现有页头形成的定位包含块偏移，不改变页头本身。
      const cssTop=parseFloat(window.getComputedStyle(element).top),offset=Number.isFinite(cssTop)?button.top-cssTop:0
      if(document.fullscreenElement){detailRechargeStyle.value={visibility:'hidden',pointerEvents:'none'};return}
      let edge=width<768?Math.min(height-86,width-96):Math.max(262,height*.5+50)+button.height
      const videos=Array.from(document.querySelectorAll('video')).map(v=>v.getBoundingClientRect()).filter(v=>v.width>0&&v.height>0&&v.bottom>0&&v.top<height&&v.right>button.left-24&&v.left<button.right+24)
      for(let i=0;i<=videos.length;i++){const hit=videos.filter(v=>edge>v.bottom-56-24&&edge-button.height<v.bottom+24);if(!hit.length)break;edge=Math.min(...hit.map(v=>v.bottom-80))}
      const hidden=edge-button.height<76;detailRechargeStyle.value={top:(edge-button.height-offset)+'px',bottom:'auto',transform:'none',visibility:hidden?'hidden':'visible',pointerEvents:hidden?'none':'auto'}
    }
    let rechargePositionFrame=0
    const queueDetailRecharge=()=>{if(!detailRechargeVisible.value){rechargeSizeObserver?.disconnect();observedRechargeElement=undefined;return;}if(typeof window==='undefined'||typeof window.requestAnimationFrame!=='function')return;if(rechargePositionFrame)window.cancelAnimationFrame(rechargePositionFrame);rechargePositionFrame=window.requestAnimationFrame(()=>{rechargePositionFrame=0;positionDetailRecharge()})}
    watch(()=>[detailRechargeVisible.value,route.fullPath],queueDetailRecharge,{flush:'post'})
    onMounted(()=>{window.addEventListener('scroll',queueDetailRecharge,{passive:true,capture:true});window.addEventListener('resize',queueDetailRecharge);document.addEventListener('fullscreenchange',queueDetailRecharge);document.addEventListener('loadedmetadata',queueDetailRecharge,true);queueDetailRecharge()})
    onBeforeUnmount(()=>{rechargeSizeObserver?.disconnect();window.removeEventListener('scroll',queueDetailRecharge,true);window.removeEventListener('resize',queueDetailRecharge);if(typeof document!=='undefined'){document.removeEventListener('fullscreenchange',queueDetailRecharge);document.removeEventListener('loadedmetadata',queueDetailRecharge,true)}if(rechargePositionFrame)window.cancelAnimationFrame(rechargePositionFrame)})

    watch(()=>[orgId.value,logined.value,clientFunctionVisible('会员储值'),route.path],async(_value,_previous,onCleanup)=>{
      let current=true
      onCleanup(()=>{current=false})
      rechargeAvailable.value=false
      if(!logined.value || !clientFunctionVisible('会员储值') || !Number.isInteger(Number(orgId.value)) || Number(orgId.value)<1000)return
      try{
        const res=await sysRequest.getDepositeSettings()
        if(current)rechargeAvailable.value=Array.isArray(res.data) && res.data.some((item:any)=>Number(item.status)===1)
      }catch{
        // 配置加载失败时保持入口隐藏，后续切页或重新登录再检查，不假定充值已开通。
      }
    },{immediate:true,flush:'sync'})
    const rechargeOffers=()=>{
      if(!rechargeVisible.value)return
      if(!logined.value){showLoginForm.value=true;return}
      router.push({path:'/main/cuscenter/deposites',query:{recharge:'1'}})
    }
    // 各页按机构权限展示入口；未登录先打开登录框，充值页自行说明档位状态。
    const headerRechargeVisible=computed(()=>Number(orgId.value)===1000 || Number(orgId.value)>1000 && Boolean(previliges.value['会员储值']))
    const headerMemberVisible=computed(()=>Number(orgId.value)===1000 || Number(orgId.value)>1000 && Boolean(previliges.value['可以开分店']))
    const headerRechargeOffers=()=>{
      if(!logined.value){showLoginForm.value=true;return}
      router.push({path:'/main/cuscenter/deposites',query:{recharge:'1'}})
    }
    const myspace=()=>{
      router.push('/main/upgradeLevel')
    }
    // 2026-09-22：安全通知直接进入独立路由，不借用业务菜单授权。
    const securityNotifications=()=>router.push('/main/cuscenter/security-notifications')
    const mobilePersonal=()=>{
      if(!logined.value){showLoginForm.value=true;return}
      menuclick({title:'个人中心',path:'/main/cuscenter',flag:'个人中心'},-1)
    }
    watch(()=>[userId.value,orgId.value],()=>{accountMenuVisible.value=false})
    const suggest=()=>{
      router.push('/main/cuscenter/suggestion')
    }
    const scrolltop=ref(0)
    
    const wxLoginstate=ref({t:createWechatLoginState(),orgId:store.getters.orgId})
    
    const t=ref(new Date().getTime())
    let tcount=10
    const getLevels=()=>{
      sysRequest.getLevels(store.getters.orgId).then(res=>{
        store.commit('user/setLevels',res.data)
      })
    }
    const isPad=computed(()=>{
      return store.getters.isPad
    })
    watch(()=>store.getters.isPad,()=>{
      console.log(store.getters.isPad)
    })

    onMounted(async ()=>{  
      if(orgInfo.value.id!=1000){
        window.document.title="服装定制平台"  
      }       
      window.setTimeout(()=>{
        if(orgInfo.value.id!=1000){
          window.document.title=orgInfo.value.orgShortName
        } 
        // if(orgInfo.value.id==1000){          
        //   if(router.currentRoute.value.path=='/main/index'){
        //     showApp.value=false;
        //   }else{
        //     showApp.value=true;
        //   }
        // }
      },1000)
      const timem=setInterval(()=>{
        if(store.getters.orgId!=0){
          const ctype=store.getters.orgId==1000?'platform':'branch'
          //appletQrcode.value=`${process.env.VUE_APP_BASE_API}/land/appletQrCode?path=pages-home-home&param=orgId-${store.getters.orgId}&clientType=${ctype}`
          appletQrcode.value=`${process.env.VUE_APP_BASE_API}/land/appletQrCode?path=pages-home-home&param=orgId-${store.getters.orgId}&clientType=${ctype}`
          clearInterval(timem)
          return
        }
      },100)
      
      await getLevels()
      const ctype=store.getters.orgId==1000?'platform':'branch'
      appletQrcode.value=`${process.env.VUE_APP_BASE_API}/land/appletQrCode?path=pages-home-home&param=orgId-${store.getters.orgId}&clientType=${ctype}`
      const path=router.currentRoute.value.path
      const type=router.currentRoute.value?.query?.type
      const parentPath=router.currentRoute.value.meta.parentPath
      for(let i=0;i<menus.value.length;i++){
        if(path===menus.value[i].path || menus.value[i].path===parentPath){
          // if(type==='3' && menus.value[i].path===parentPath){  //饰品
          //   selectedIndex.value = 4
          // }else{
            selectedIndex.value = i
          // }
        }
      }
      store.state.user.loginCallback=()=>{
        showLoginForm.value=true
      }
      store.state.user.setMenuIndex=(index)=>{
        selectedIndex.value = index
      }
      const ele=document.querySelector('.app-main')
      if(ele){
        ele?.addEventListener('scroll', ()=>{
          scrolltop.value=ele.scrollTop
        })
      }
      if(!store.getters.userInfo.id){        
        let menu=menus.value.find(item=>item.path==='/main/buycar')
        if(menu){
          menu.enabled=clientFunctionVisible('购物车')
        } 
        
      }
      if(orgInfo.value.id==1000){
        let menu=menus.value.find(item=>item.path==='/main/coursecenter')
        if(menu){
          menu.enabled=true
        }
        menu=menus.value.find(item=>item.path==='/main/helpcenter')
        if(menu){
          menu.enabled=true
        } 
      }
      const tt=window.setInterval(()=>{
        for(const menu of menus.value){
          if(menu.flag){
            menu.enabled=clientFunctionVisible(menu.flag)
          }
          if(menu.enabled){
            if(menu.flag=="版型库浏览"){
              if(!previliges.value['版型下单']){
                menu.title="款式库"
              }
            }
          }
        }        
        tcount--;
        if(tcount<=0){
          window.clearInterval(tt)
        }
      },200)
      if(store.getters.userInfo.id){
        initWebSocket()
      }
    })
    watch(()=>showLoginForm.value,()=>{
      if(!showLoginForm.value && bingdingT){
        window.clearInterval(bingdingT)
      }
    })
    return {
      iconSetting,myspace,formInfo,showRegAccountForm,newAccountInfo,getValidaCodeForReg,showPhoneBinding,wechatScanError,previliges,
      logout,suggest,activeKey,loginInfo,regAccount,accountExists,codeLogin,wxLogin,bindingData,sendCode,orgId,showApp,appletQrcode,
      store,path,updatePwd,loginClick,acceptTerm,codeAcceptTerm,regAccountFormInfo,wxloginData,wxLoginstate,bindPhoneButton,userId,showupdatePwd,
      pageText,pageImage,navigationTitle,navigationImages,mobileNavigationMenus,
      passwordReminder,menus,validatePassword,logined,showRegForm,showSmsTerms,retryValidatePassword,isWxLogin,t,bindingPhone,bingding,scaleClick,isForeceReset,
       vipVisibleFunctions,vipAllowedFunctions,clientFunctionVisible,helpCenterVisible,
      navigationMenus,guestRechargeVisible,detailRechargeVisible,detailRechargeStyle,rechargeVisible,rechargeOffers,headerRechargeVisible,headerMemberVisible,headerRechargeOffers,mobilePersonal,menuclick,accountMenuVisible,securityNotifications,showLoginForm,confirmExit,viewAccount,getValidaCodeText,keyChanged,userInfo,pwdError,orgInfo,downloadIcon,
      bindingLoginRequested,continueBinding,inlineBindingAuthenticated,closeInlineBinding,bindingFlow,verifiedBindingPreview,loginContext,loginPreview,selectedIndex,scrolltop,open,accountInfo,validation,getValidaCode,codeState,islogin,resetPwd,resetPwdClick,isPad
    }
  },
  components: {
    ClientSkinPicker,
    ProductConsultationInfo,WechatBindingFlow,MobileNavigation,Hanbuger,UserOutlined,KeyOutlined,MobileOutlined,MailOutlined,
    Navgater,QrcodeVue,
    CBridge,
    wxlogin,
    Language
  }
})
